import type { Translations } from '@/smarttext/translationsTypes.ts';

export type TranslationDictionary = { [key: string]: string };

type CreateTranslationDictionaryProps = {
  lang: string;
  locale: string;
  translations: Translations;
};
export const createTranslationDictionary = ({
  lang,
  locale,
  translations,
}: CreateTranslationDictionaryProps): TranslationDictionary => ({
  ...(translations[lang.toLowerCase()] || {}),
  ...(translations[locale.toLowerCase()] || {}),
});

export const getTranslationServer = (key: string, translationDictionary: TranslationDictionary): string =>
  translationDictionary?.[key] || '';
